<!--
 * @创建文件时间: 2020-04-06 15:11:51
 * @最后修改人: lfq
 * @最后修改时间: 2020-06-12 15:49:00
 * @文件介绍: 路段划分方法
 -->
<template>
  <d2-container>
    <div v-show="!showTabFom">
      <el-row style="margin-bottom: 20px">
        <el-col :span="4">
          <popover-form
            popoverWidth="680"
            :formConfig="advSearch"
            v-model="searchForm"
            @onSubmit="searchTable"></popover-form>
        </el-col>
        <el-col :span="20">
          <div class="text-align_right">
          <el-button type="primary" v-if="!tableUse.show &&verifyAuthority('system.gsims.pmdSectionMaintenance.add')" @click="addRow">新增</el-button>
          </div>
        </el-col>
      </el-row>
      <div>
        <dynamic-table
          :tableSet="tableSet"
          :tableData="tableData"
          :table-use="tableUse"
          :pageIndex="pageIndex"
          :pageShow="false"
          :pageShowX = "true"
          @goPageIndex="goPageIndex($event)"
          :pageCount="pageCount"
          @rowClick="rowClick($event)"
           >
        </dynamic-table>
      </div>
    </div>
    <div v-show="showTabFom">
      <div>
        <div>
          <div class="text-align_right">
              <el-button-group>
                  <el-button type="primary" v-if="(operationType==1||operationType==2)" @click="dataSubmit">保存</el-button>
                  <el-button type="primary" @click="close">返回</el-button>
              </el-button-group>
          </div>
          <divider title="路段划分方法信息" />
          <dynamic-form ref="form" :formConfig="formConfig" :disabled="!(operationType==1||operationType==2)" v-model="form"></dynamic-form>
        </div>
        <!-- 子表 -->
        <div>
          <divider title="路段划分方法详情" />
          <div class="text-align_right" style="margin-bottom:10px;">
                <el-button type="primary" v-if="(operationType==1||operationType==2)" @click="addChildRow">新增</el-button>
          </div>
          <dynamic-table 
            :tableSet="childTableSet" 
            :tableData="childTableData" 
            :pageIndex="childPageIndex" 
            :pageCount="childPageCount" 
            :operationShow="(this.operationType===1||this.operationType===2)"
            :pageShow="false"
            :maxHeight="'320'"
            @rowClick="childRowClick($event)">
          </dynamic-table>
          <dialog-form ref='childForm' dialogTitle="详情" :formConfig='childFormConfig' :disabled="(!(childOperationType==1||childOperationType==2))" :dialogFormVisible.sync="dialogFormVisible" v-model="childForm" @onSubmit='childSubmit'></dialog-form>
        </div>
      </div>
    </div>
    <template slot="footer" v-if="showTabFom">
        <billing-info :billingInfo="form"></billing-info>
    </template>
  </d2-container>
</template>
<style>
</style>
<script>
import util from '@/libs/util.js'
export default {
  name: "pmdSectionMaintenance",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props:{
    tableUse: {
      type: Object,
      default: () => {
        return {
          show: false,
          size: "small",
          type: "primary",
          plain: true,
          round: false,
          circle: false,
          loading: false,
          disabled: false,
          types:0,
          isFull:"",
          title: "使用",
          name: "使用"
        };
      }
    }
  },
  data() {
    return {
      showTabFom:false,//表格表单转换状态
      operationType:1,//主表操作状态
      childOperationType:1,//子表操作状态

      /********* 查询---*/
      searchForm:{
        surfaceType: '',//适用面层
        source: '',//来源 
        partitionName: '',//方法名称
      },
      advSearch:{
       "list": [
          {
            "type": "input",
            "icon": "icon-input",
            "options": {
              "width": "250px",
              "defaultValue": "",
              "required": false,
              "dataType": "string",
              "pattern": "",
              "placeholder": "",
              "customClass": "",
              "disabled": false,
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true,
              "showPassword": false,
              "remoteFunc": "func_1586328531242",
              "remoteOption": "option_1586328531242"
            },
            "name": "路段划分方法",
            "key": "1586328531242",
            "model": "partitionName",
            "rules": [
              {
                "type": "string",
                "message": "格式不正确"
              },
            ]
          },
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "",
              "multiple": false,
              "disabled": false,
              "clearable": false,
              "placeholder": "请选择",
              "required": false,
              "showLabel": false,
              "width": "250px",
              "options": [
                {
                  "value": "Option 1"
                }
              ],
              "remote": true,
              "remoteType": "func",
              "remoteOption": "option_1586328567134",
              "filterable": false,
              "remoteOptions": [],
              "props": {
                "value": "name",
                "label": "name"
              },
              "remoteFunc": this.getDiction,
              "customClass": "",
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true
            },
            "name": "适用面层类型",
            "key": "1586328567134",
            "model": "surfaceType",
            "rules": [
            ]
          },
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "",
              "multiple": false,
              "disabled": false,
              "clearable": false,
              "placeholder": "请选择",
              "required": false,
              "showLabel": false,
              "width": "250px",
              "options": [
                {
                  "value": "0",
                  "label": "自定义"
                },
                {
                  "value": "1",
                  "label": "系统默认库"
                }
              ],
              "remote": false,
              "remoteType": "func",
              "remoteOption": "option_1586328567134",
              "filterable": false,
              "remoteOptions": [],
              "props": {
                "value": "value",
                "label": "label"
              },
              "remoteFunc": "func_1586328567134",
              "customClass": "",
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true
            },
            "name": "方法来源",
            "key": "1586332500192",
            "model": "source",
            "rules": [
            ]
          },
          ],
          "config": {
            "labelWidth": 100,
            "labelPosition": "right",
            "size": "medium",
            "customClass": ""
          }
      },
      /********* 查询---*/
      /**********主表表格 */
      tableSet: {
        tableColumn: [{
            prop:'partitionName',
            label:'路段划分方法'
          },{
            prop:'surfaceType',
            label:'适用面层类型'
          },{
            prop:"source",
            label:"方法来源",
            type:'tag',
            options:[
              {value:'0',color:'',label:'自定义'},
              {value:'1',color:'info',label:'系统默认库'}
            ]
          },{
            prop:'remark',
            label:'备注'
          }
        ],
        tableColBtn: [
        {
          show: true,
          size:'mini',
          type:'primary',
          plain: true,
          round: false,
          circle: false,
          loading: false,
          disabled: false,
          icon:'el-icon-view',
          title:'查看',
          name:'查看',
          click: this.rowClick
        },{
          show: this.verifyAuthority('system.gsims.pmdSectionMaintenance.edit'),
          size:'mini',
          type:'primary',
          plain: true,
          round: false,
          circle: false,
          loading: false,
          disabled: false,
          icon:'el-icon-edit',
          title:'编辑',
          name:'编辑',
          click: this.edit
        },{
          show: this.verifyAuthority('system.gsims.pmdSectionMaintenance.del'),
          size:'mini',
          type:'danger',
          plain: true,
          round: false,
          circle: false,
          loading: false,
          disabled: false,
          icon:'el-icon-delete',
          title:'删除',
          name:'删除',
          click: this.del
        }]
      },
      tableData: [],
      pageIndex:1,
      pageSize:10,
      pageCount:0,
      /************主表表单 */
      form:{
        rowCode :0,
        partitionName :'',/// 路段划分方法名称
        source :'',/// 方法来源
        surfaceType :'',/// 适用面层类型
        isSystem :'',/// 是否系统
        indexType:"",
        remark :'',/// 备注
        createUser :'',
        createUserName :'',
        createTime :'',
        updateUser :'',
        updateUserName :'',
        updateTime :'',
        status :'',
        r1 :'',
        r2 :'',
        r3 :'',
        r4 :'',
        r5 :'',
        sublist :[],
      },
      formConfig:{
        "list": [
          {
            "type": "input",
            "icon": "icon-input",
            "options": {
              "width": "250px",
              "defaultValue": "",
              "required": true,
              "dataType": "string",
              "pattern": "",
              "placeholder": "",
              "customClass": "",
              "disabled": false,
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true,
              "showPassword": false,
              "remoteFunc": "func_1586328531242",
              "remoteOption": "option_1586328531242"
            },
            "name": "路段划分方法",
            "key": "1586328531242",
            "model": "partitionName",
            "rules": [
              {
                "type": "string",
                "message": "格式不正确"
              },
              {
                "required": true,
                "message": "必须填写"
              }
            ]
          },
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "",
              "multiple": true,
              "disabled": false,
              "clearable": false,
              "placeholder": "请选择",
              "required": true,
              "showLabel": false,
              "width": "250px",
              "options": [
                {
                  "value": "value"
                }
              ],
              "remote": true,
              "remoteType": "func",
              "remoteOption": "option_1586328567134",
              "filterable": false,
              "remoteOptions": [],
              "props": {
                "value": "name",
                "label": "name"
              },
              "remoteFunc": this.getDiction,
              "customClass": "",
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true
            },
            "name": "路段划分指标",
            "key": "1586332500192",
            "model": "indexType",
            "rules": [
              {
                "required": true,
                "message": "必须填写"
              }
            ]
          },
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "",
              "multiple": false,
              "disabled": false,
              "clearable": false,
              "placeholder": "请选择",
              "required": true,
              "showLabel": false,
              "width": "250px",
              "options": [
                {
                  "value": "Option 1"
                }
              ],
              "remote": true,
              "remoteType": "func",
              "remoteOption": "option_1586328567134",
              "filterable": false,
              "remoteOptions": [],
              "props": {
                "value": "name",
                "label": "name"
              },
              "remoteFunc": this.getDiction,
              "customClass": "",
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true
            },
            "name": "适用面层类型",
            "key": "1586328567134",
            "model": "surfaceType",
            "rules": [
              {
                "required": true,
                "message": "必须填写"
              }
            ]
          },
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "",
              "multiple": false,
              "disabled": false,
              "clearable": false,
              "placeholder": "请选择",
              "required": true,
              "showLabel": false,
              "width": "250px",
              "options": [
                {
                  "value": "0",
                  "label": "自定义"
                },
                {
                  "value": "1",
                  "label": "系统默认库"
                }
              ],
              "remote": false,
              "remoteType": "func",
              "remoteOption": "option_1586328567134",
              "filterable": false,
              "remoteOptions": [],
              "props": {
                "value": "value",
                "label": "label"
              },
              "remoteFunc": "func_1586328567134",
              "customClass": "",
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true
            },
            "name": "方法来源",
            "key": "1586332500192",
            "model": "source",
            "rules": [
              {
                "required": true,
                "message": "必须填写"
              }
            ]
          },
          {
            "type": "textarea",
            "icon": "icon-diy-com-textarea",
            "options": {
              "width": "250px",
              "defaultValue": "",
              "required": false,
              "disabled": false,
              "pattern": "",
              "placeholder": "",
              "customClass": "",
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true,
              "remoteFunc": "func_1586328675346",
              "remoteOption": "option_1586328675346"
            },
            "name": "备注",
            "key": "1586328742051",
            "model": "remark",
            "rules": []
          }
        ],
        "config": {
          "labelWidth": 160,
          "labelPosition": "right",
          "size": "small",
          "customClass": "",
          "ui": "element",
          "layout": "horizontal",
          "labelCol": 3,
          "width": "100%"
        }
      },
      /************子表 */
      childTableSet:{
        tableColumn: [{
            prop:'highwayLevel',
            label:'公路等级',
          },{
            prop:'maintenanceType',
            label:'养护类型',
          },{
            prop:'indexType',
            label:'路段划分指标',
          },{
            prop:'threshold1',
            label:'上限值',
          },{
            prop:'threshold2',
            label:'下限值',
          },
          // {
          //   prop:'threshold3',
          //   label:'界限值3',
          // },{
          //   prop:'threshold4',
          //   label:'界限值4',
          // },{
          //   prop:'threshold5',
          //   label:'界限值5',
          // },{
          //   prop:'threshold6',
          //   label:'界限值6',
          // },
        ],
        tableColBtn: [
        {
          show: true,
          size:'mini',
          type:'primary',
          plain: true,
          round: false,
          circle: false,
          loading: false,
          disabled: false,
          icon:'el-icon-edit',
          title:'编辑',
          name:'编辑',
          click: this.childEdit
        },
        {
          show: true,
          size:'mini',
          type:'danger',
          plain: true,
          round: false,
          circle: false,
          loading: false,
          disabled: false,
          icon:'el-icon-delete',
          title:'删除',
          name:'删除',
          click: this.childDel
        }]
      },
      indexNum:1,
      childTableData: [],
      childPageIndex:1,
      childPageSize:10,
      childPageCount:0,
      deleteList:[],
      dialogFormVisible: false,
      /** */
      childForm:{
        rowCode :"",
        pCode :0,/// 主表idint
        highwayLevel :'',/// 公路等级
        maintenanceType :'',/// 养护类型
        indexType :'',/// 路段划分指标
        threshold1 :0,/// 上限值int
        threshold2 :0,/// 下限值int
        threshold3 :0,/// 界限值3：用于区分中修养护与大修养护的指标临界值int
        threshold4 :0,/// 界限值4int
        threshold5 :0,/// 界限值5int
        threshold6 :0,/// 界限值6int
        remark :'',/// 备注
        createUser :'',/// 制单人
        createUserName :'',/// 制单人姓名
        createTime :'',
        updateUser :'',
        updateUserName :'',
        updateTime :'',
        status :'',
        r1 :'',
        r2 :'',
        r3 :'',
        r4 :'',
        r5 :'',
      },
      childFormConfig:{
          "list": [
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "",
              "multiple": false,
              "disabled": false,
              "clearable": false,
              "placeholder": "请选择",
              "required": true,
              "showLabel": false,
              "width": "250px",
              "options": [
                {
                  "value": "Option 1"
                }
              ],
              "remote": true,
              "remoteType": "func",
              "remoteOption": "option_1586328567134",
              "filterable": false,
              "remoteOptions": [],
              "props": {
                "value": "name",
                "label": "name"
              },
              "remoteFunc": this.getDiction,
              "customClass": "",
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true
            },
            "name": "公路等级",
            "key": "1586328567134",
            "model": "highwayLevel",
            "rules": [
              {
                "required": true,
                "message": "必须填写"
              }
            ]
          },
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "",
              "multiple": false,
              "disabled": false,
              "clearable": false,
              "placeholder": "请选择",
              "required": true,
              "showLabel": false,
              "width": "250px",
              "options": [
                {
                  "value": "value"
                }
              ],
              "remote": true,
              "remoteType": "func",
              "remoteOption": "option_1586328567134",
              "filterable": false,
              "remoteOptions": [],
              "props": {
                "value": "name",
                "label": "name"
              },
              "remoteFunc": this.getDiction,
              "customClass": "",
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true
            },
            "name": "路段划分指标",
            "key": "1586332500192",
            "model": "indexType",
            "rules": [
              {
                "required": true,
                "message": "必须填写"
              }
            ]
          },
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "",
              "multiple": false,
              "disabled": false,
              "clearable": false,
              "placeholder": "请选择",
              "required": true,
              "showLabel": false,
              "width": "250px",
              "options": [
                {
                  "value": "value"
                }
              ],
              "remote": true,
              "remoteType": "func",
              "remoteOption": "option_1586328567134",
              "filterable": false,
              "remoteOptions": [],
              "props": {
                "value": "name",
                "label": "name"
              },
              "remoteFunc": this.getDictions,
              "customClass": "",
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true
            },
            "name": "养护类型",
            "key": "路段划分养护类型",
            "model": "maintenanceType",
            "rules": [
              {
                "required": true,
                "message": "必须填写"
              }
            ]
          },
          {
            "type": "number",
            "icon": "icon-number",
            "options": {
              "width": "250px",
              "required": true,
              "defaultValue": 0,
              "min": 0,
              "max": 100,
              "step": 1,
              "disabled": false,
              "controlsPosition": "",
              "customClass": "",
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true,
              "remoteFunc": "func_1586332880636",
              "remoteOption": "option_1586332880636"
            },
            "name": "上限值",
            "key": "1586332880636",
            "model": "threshold1",
            "rules": [
              {
                "required": true,
                "message": "必须填写"
              }
            ]
          },
          {
            "type": "number",
            "icon": "icon-number",
            "options": {
              "width": "250px",
              "required": true,
              "defaultValue": 0,
              "min": 0,
              "max": 100,
              "step": 1,
              "disabled": false,
              "controlsPosition": "",
              "customClass": "",
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true,
              "remoteFunc": "func_1586332880636",
              "remoteOption": "option_1586332880636"
            },
            "name": "下限值",
            "key": "1586332914905",
            "model": "threshold2",
            "rules": [
              {
                "required": true,
                "message": "必须填写"
              }
            ]
          },
          // {
          //   "type": "number",
          //   "icon": "icon-number",
          //   "options": {
          //     "width": "250px",
          //     "required": true,
          //     "defaultValue": 0,
          //     "min": 0,
          //     "max": 100,
          //     "step": 1,
          //     "disabled": false,
          //     "controlsPosition": "",
          //     "customClass": "",
          //     "labelWidth": 100,
          //     "isLabelWidth": false,
          //     "hidden": false,
          //     "dataBind": true,
          //     "remoteFunc": "func_1586332880636",
          //     "remoteOption": "option_1586332880636"
          //   },
          //   "name": "界限值3",
          //   "key": "1586332918467",
          //   "model": "threshold3",
          //   "rules": [
          //     {
          //       "required": true,
          //       "message": "必须填写"
          //     }
          //   ]
          // },
          // {
          //   "type": "number",
          //   "icon": "icon-number",
          //   "options": {
          //     "width": "250px",
          //     "required": false,
          //     "defaultValue": 0,
          //     "min": 0,
          //     "max": 100,
          //     "step": 1,
          //     "disabled": false,
          //     "controlsPosition": "",
          //     "customClass": "",
          //     "labelWidth": 100,
          //     "isLabelWidth": false,
          //     "hidden": false,
          //     "dataBind": true,
          //     "remoteFunc": "func_1586332880636",
          //     "remoteOption": "option_1586332880636"
          //   },
          //   "name": "界限值4",
          //   "key": "1586332924303",
          //   "model": "threshold4",
          //   "rules": []
          // },
          // {
          //   "type": "number",
          //   "icon": "icon-number",
          //   "options": {
          //     "width": "250px",
          //     "required": false,
          //     "defaultValue": 0,
          //     "min": 0,
          //     "max": 100,
          //     "step": 1,
          //     "disabled": false,
          //     "controlsPosition": "",
          //     "customClass": "",
          //     "labelWidth": 100,
          //     "isLabelWidth": false,
          //     "hidden": false,
          //     "dataBind": true,
          //     "remoteFunc": "func_1586332880636",
          //     "remoteOption": "option_1586332880636"
          //   },
          //   "name": "界限值5",
          //   "key": "1586332931356",
          //   "model": "threshold5",
          //   "rules": []
          // },
          // {
          //   "type": "number",
          //   "icon": "icon-number",
          //   "options": {
          //     "width": "250px",
          //     "required": false,
          //     "defaultValue": 0,
          //     "min": 0,
          //     "max": 100,
          //     "step": 1,
          //     "disabled": false,
          //     "controlsPosition": "",
          //     "customClass": "",
          //     "labelWidth": 100,
          //     "isLabelWidth": false,
          //     "hidden": false,
          //     "dataBind": true,
          //     "remoteFunc": "func_1586332880636",
          //     "remoteOption": "option_1586332880636"
          //   },
          //   "name": "界限值6",
          //   "key": "1586332936605",
          //   "model": "threshold6",
          //   "rules": []
          // },
          {
            "type": "textarea",
            "icon": "icon-diy-com-textarea",
            "options": {
              "width": "250px",
              "defaultValue": "",
              "required": false,
              "disabled": false,
              "pattern": "",
              "placeholder": "",
              "customClass": "",
              "labelWidth": 100,
              "isLabelWidth": false,
              "hidden": false,
              "dataBind": true,
              "remoteFunc": "func_1586328675346",
              "remoteOption": "option_1586328675346"
            },
            "name": "备注",
            "key": "1586328742051",
            "model": "remark",
            "rules": []
          }
        ],
        "config": {
          "labelWidth": 160,
          "labelPosition": "right",
          "size": "small",
          "customClass": "",
          "ui": "element",
          "layout": "horizontal",
          "labelCol": 3,
          "width": "100%"
        }
      }
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {

  },
  //方法集合
  methods: {
    /********字典获取 ******/
    getDiction(target, targets){
      let name=target.form.name;
      this.$http.post(this.$url.getDict, {
          search: name
      }).then(res => {
          let { data } = res;
          target.setList(data);
      })
    },
    getDictions(target, targets){
      let name=target.form.key;
      this.$http.post(this.$url.getDict, {
          search: name
      }).then(res => {
          let { data } = res;
          target.setList(data);
      })
    },
    //主表操作//
    addRow(){//新增
      this.showTabFom = true;
      this.resetForm('form');
      this.operationType = 1;
      this.childTableData=[];
      this.deleteList=[];
    },
    searchTable() {//获取表格数据
      this.pageIndex=1;
      let that=this;
      this.$http.postHandle("", this.$url.measureslibrary.getsectionmaintenances, {
          ...that.searchForm,
          pageIndex:this.pageIndex,
          pageSize:this.pageSize
      }).then(res => {
          this.tableData = res.data;
          this.pageCount=res.pageCount;
      })
    },
    goPageIndex(pageIndex,pageSize){//分页
      this.pageIndex=pageIndex;
      this.pageSize = pageSize
      let that=this;
      this.$http.postHandle("", this.$url.measureslibrary.getsectionmaintenances, {
          ...that.searchForm,
          pageIndex:this.pageIndex,
          pageSize:this.pageSize,
      }).then(res => {
          this.tableData = res.data;
          this.pageCount=res.pageCount;
      })
    },
    rowClick(row){//查看
      this.operationType = 3;
      this.$http.post(this.$url.measureslibrary.getsectionmaintenances, {
          rowCode:row.rowCode,
      })
      .then(res => {
        this.form = res.data[0];
        this.form.indexType = this.form.indexType.split(",")
        this.childTableData=res.data[0].sublist;
        this.showTabFom = true;
      })
    },
    edit(row,index){//编辑
      this.operationType = 2;
      this.$http.post(this.$url.measureslibrary.getsectionmaintenances, {
          rowCode:row.rowCode,
      })
      .then(res => {
        this.form = res.data[0];
        this.form.indexType = this.form.indexType.split(",")
        this.childTableData=res.data[0].sublist;
        this.showTabFom = true;
        this.deleteList=[];
      })
    },
    del(row,index){//删除
      let forms=this.$formSetForm(this.form,row);
        this.$msgDel(this.$url.measureslibrary.operationsectionmaintenance,{sectionMaintenance:forms,operationType:8}).then(res=>{
           this.searchTable();
        })
    },
    dataSubmit() {//操作
      this.$refs.form.submit().then(res=>{
        let form = this.$formSetForm(this.form,this.form);
        form.indexType = form.indexType.toString()
        form.sublist=this.$listSetList(this.childTableData,this.deleteList);
        this.$http.postHandle('保存',this.$url.measureslibrary.operationsectionmaintenance,{
          sectionMaintenance:form,
          operationType:this.operationType
        }).then(res=>{
            this.showTabFom = false;
            this.searchTable()
        })
      })
    },
    close(){//返回
      this.$closePage(this.operationType).then(()=>{
        this.showTabFom = false;
        this.searchTable();
      })
    },
    //子表操作//
    goChildPageIndex(val){//分页
      this.childPageIndex=val;
      this.getChildTableData();
    },
    childRowClick(row){//查看
      this.childForm=this.$formSetForm(this.childForm,row);
      // this.childForm.indexType=this.setArrStr(row,true).indexType;
      this.dialogFormVisible=true;
      this.childOperationType = 3;
    },
    addChildRow(){//新增子表
      this.resetForm('childForm')
      this.dialogFormVisible=true;
      this.childOperationType = 1;
    },
    childEdit(row,index){//编辑
      this.indexNum=index;
      this.childForm=this.$formSetForm(this.childForm,row);
      // this.childForm.indexType=this.setArrStr(row,true).indexType;
      this.dialogFormVisible=true;
      this.childOperationType = 2;
    },
    childDel(row,index){//删除
      this.$localDel().then(()=>{
        if(row.rowCode == ""){
          this.childTableData.splice(index,1);
        }else{
          let forms=this.$formSetForm(this.childForm,row);
          forms.status=3;
          this.childTableData.splice(index,1);
          this.deleteList.push(forms);
        }
      })
    },
    childSubmit(){//保存
      let letForm=this.$formSetForm(this.childForm,this.childForm);
      letForm.pCode=this.form.rowCode;

      this.dialogFormVisible=false;
      if(this.childOperationType==1){
        this.childTableData.splice(0,0,letForm);
      }else if(this.childOperationType==2){
        this.childTableData.splice(this.indexNum,1,letForm);
      }
    },
    setArrStr(row,bools){//字段-字符串与数组之间转换
      let forms={
        indexType :'',/// 面层类型/适用面层
      };
      if(bools){//字符串转换数组
        if(row.indexType!=null&&row.indexType!=""){
          forms.indexType=row.indexType.split(",")
        }else{
          forms.indexType=[]
        }
      }else{//数组转换字符串
        if(row.indexType.length>0){
          forms.indexType=row.indexType.join(",");
        }else{
          forms.indexType=""
        }
      }
      return forms
    },
    //重置
	  resetForm(formName){
      let that = this;
      that.$nextTick(()=>{
         that.$refs[formName].resetForm();
         formName==='form'&&(that.form.sublist=[]);
      })
    },
    //获取指标
    getIndexType(target, targets){
      let arr = this.deepCopy(this.form.indexType)
      let indexTypeObj = []
      for(let item of arr){
        let indexType = {
          "label":"",
          "value":""
        }
        indexType.label = item
        indexType.value = item
        indexTypeObj.push(indexType)
      }
      target.setList(indexTypeObj)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.searchTable();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
};
</script>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/decisionBase/parametersLibrary/pmdSectionMaintenance.vue"
}
</vue-filename-injector>
